(function ($, debounce) {
  'use strict';

  $(document).ready(function () {
    $(".mobile_menu_toggle").on("click", debounce((element) => {
      $("body").toggleClass("fixed");
      $(".mobile_menu_toggle > i").toggleClass("hidden");
      $(this).toggleClass("open")
      $("#block-ekw-main-menu > .menu").toggleClass("open");
    }, 100));

    $(".menu-item--expanded > .flex a").on("click", (e) => {
      e.preventDefault();
    });

    $(".menu-item--expanded").on("click", debounce((e) => {
      $(e.currentTarget).toggleClass("open");
    }, 100));

    $("#Pradella_00000177467466075437288290000003992304305155049613_").on("mouseenter", function(e) {
      $("#Pradella").hide();
    });
    $("#Pradella_00000177467466075437288290000003992304305155049613_").on("mouseleave", function(e) {
      $("#Pradella").show();
    })
  });


})(jQuery, Drupal.debounce);
